// extracted by mini-css-extract-plugin
module.exports = {"StaggeredImages":"StaggeredImages_StaggeredImages__BbuiL","inner":"StaggeredImages_inner__1wFy6"};